import styled, { css } from 'styled-components';

import { Frame, TExtra } from './StyledTemplates';

interface IProps {
    order?: 'asc' | 'desc';
}

const SortArrow = (props: IProps) => {
    const { order } = props;
    return (
        <Wrapper>
            <Svg selected={order === 'asc'}>
                <path d="M4.23212 0.645386C4.11498 0.645386 3.99781 0.684692 3.90827 0.763531L0.243846 3.98967C0.112843 4.10501 0.0735435 4.27835 0.144542 4.42917C0.215082 4.58 0.38265 4.67807 0.567703 4.67807H7.89654C8.0816 4.67807 8.24916 4.58 8.3197 4.42917C8.3907 4.27835 8.3514 4.10501 8.2204 3.98967L4.55598 0.763531C4.46643 0.684692 4.34927 0.645386 4.23212 0.645386Z" />
            </Svg>
            <Svg selected={order === 'desc'}>
                <path d="M4.1225 4.33C4.00536 4.33 3.8882 4.29069 3.79865 4.21186L0.134227 0.985711C0.00322382 0.870377 -0.0360756 0.697035 0.0349225 0.546213C0.105463 0.39539 0.273031 0.29732 0.458084 0.29732H7.78692C7.97198 0.29732 8.13954 0.39539 8.21008 0.546213C8.28108 0.697035 8.24178 0.870377 8.11078 0.985711L4.44636 4.21186C4.35681 4.29069 4.23965 4.33 4.1225 4.33Z" />
            </Svg>
        </Wrapper>
    );
};

const Svg = styled.svg.attrs((props) => {
    return { ...props, fill: 'none', width: '11', height: '6', xmlns: 'http://www.w3.org/2000/svg' };
})<{ selected?: boolean }>`
    path {
        fill: #6c757d;
    }

    ${({ selected }) =>
        !selected &&
        css`
            path {
                opacity: 0.3;
            }
        `}
`;

const Wrapper = styled(Frame)<{ extra?: TExtra }>`
    width: 11px;
    height: 11px;
    margin-left: 10px;
    cursor: pointer;

    svg {
        display: flex;
    }

    gap: 1px;

    ${({ extra }) => extra}
`;

export default SortArrow;
